"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _oxygenConstants = require("@8x8/oxygen-constants");
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenUserStatus = _interopRequireDefault(require("@8x8/oxygen-user-status"));
var _CameraIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/CameraIcon"));
var _UserIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/UserIcon"));
var _UserGroupsIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/UserGroupsIcon"));
var _UserIcon2 = _interopRequireDefault(require("@8x8/oxygen-icon/novo/UserIcon"));
var _UsersIcon = _interopRequireDefault(require("@8x8/oxygen-icon/novo/UsersIcon"));
var _StyledAvatar = require("../styled/StyledAvatar");
var _getIconSizePx = _interopRequireDefault(require("../utils/getIconSizePx"));
var _getInitials = _interopRequireDefault(require("../utils/getInitials"));
var _excluded = ["onClick", "onEdit", "theme", "testId", "src", "name"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // Novo icons
var Avatar = /*#__PURE__*/function (_PureComponent) {
  _inherits(Avatar, _PureComponent);
  var _super = _createSuper(Avatar);
  function Avatar() {
    var _this;
    _classCallCheck(this, Avatar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleEdit", function (e) {
      var onEdit = _this.props.onEdit;
      e.stopPropagation();
      return onEdit(e);
    });
    _defineProperty(_assertThisInitialized(_this), "renderEditOverlay", function () {
      var _this$props = _this.props,
        showEditOverlay = _this$props.showEditOverlay,
        size = _this$props.size;
      if (showEditOverlay && [_oxygenConstants.avatarSize.sizeLarge, _oxygenConstants.avatarSize.sizeXlarge, _oxygenConstants.avatarSize.size2xlarge, _oxygenConstants.avatarSize.size3xlarge].includes(size)) {
        return /*#__PURE__*/_react["default"].createElement(_StyledAvatar.EditOverlayWrapper, null, /*#__PURE__*/_react["default"].createElement(_StyledAvatar.EditOverlay, {
          onClick: _this.handleEdit,
          size: size
        }, /*#__PURE__*/_react["default"].createElement(_CameraIcon["default"], null)));
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "renderUserStatus", function () {
      var _this$props2 = _this.props,
        userStatus = _this$props2.userStatus,
        size = _this$props2.size;
      if (!userStatus) {
        return false;
      }
      if (typeof userStatus !== 'string') {
        return /*#__PURE__*/_react["default"].createElement(_StyledAvatar.UserStatusWrapper, null, userStatus);
      }
      if ([_oxygenConstants.avatarSize.size2xsmall, _oxygenConstants.avatarSize.sizeXsmall, _oxygenConstants.avatarSize.sizeSmall, _oxygenConstants.avatarSize.sizeMedium, _oxygenConstants.avatarSize.sizeLarge, _oxygenConstants.avatarSize.sizeXlarge, _oxygenConstants.avatarSize.size2xlarge].includes(size)) {
        var statusSize = [_oxygenConstants.avatarSize.size2xsmall, _oxygenConstants.avatarSize.sizeXsmall, _oxygenConstants.avatarSize.sizeSmall, _oxygenConstants.avatarSize.sizeMedium].includes(size) ? 'small' : 'large';
        return /*#__PURE__*/_react["default"].createElement(_StyledAvatar.UserStatusWrapper, null, /*#__PURE__*/_react["default"].createElement(_oxygenUserStatus["default"], {
          size: statusSize,
          status: userStatus
        }));
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "renderAvatar", function () {
      var _this$props3 = _this.props,
        children = _this$props3.children,
        size = _this$props3.size,
        src = _this$props3.src,
        name = _this$props3.name,
        isGroup = _this$props3.isGroup,
        theme = _this$props3.theme,
        maxInitials = _this$props3.maxInitials;
      if (children) {
        return children;
      }
      if (src) {
        return /*#__PURE__*/_react["default"].createElement(_StyledAvatar.StyledAvatarImage, {
          size: size,
          src: src,
          alt: name
        });
      }
      var trimmedName = name.trim();
      if (trimmedName) {
        return (0, _getInitials["default"])(trimmedName, maxInitials);
      }
      var GroupIcon = theme.iconSet === 'novo' ? _UsersIcon["default"] : _UserGroupsIcon["default"];
      var UserIcon = theme.iconSet === 'novo' ? _UserIcon2["default"] : _UserIcon["default"];
      var Icon = isGroup ? GroupIcon : UserIcon;
      return /*#__PURE__*/_react["default"].createElement(Icon, {
        size: (0, _getIconSizePx["default"])({
          size: size,
          theme: theme
        }),
        "aria-hidden": "true"
      });
    });
    _defineProperty(_assertThisInitialized(_this), "shouldShowStatusBorder", function () {
      var _this$props4 = _this.props,
        hasStatusBorder = _this$props4.hasStatusBorder,
        userStatus = _this$props4.userStatus;
      return hasStatusBorder && Object.values(_oxygenConstants.avatarUserStatus).includes(userStatus);
    });
    return _this;
  }
  _createClass(Avatar, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        onClick = _this$props5.onClick,
        onEdit = _this$props5.onEdit,
        theme = _this$props5.theme,
        testId = _this$props5.testId,
        src = _this$props5.src,
        name = _this$props5.name,
        rest = _objectWithoutProperties(_this$props5, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement(_StyledAvatar.StyledAvatar, _extends({}, (0, _oxygenConfig.getTestAttributes)(testId), {
        hasStatusBorder: this.shouldShowStatusBorder(),
        onClick: onClick,
        tabIndex: onClick && 0,
        role: onClick && 'button'
      }, rest), this.renderAvatar(), this.renderEditOverlay(), this.renderUserStatus()));
    }
  }]);
  return Avatar;
}(_react.PureComponent);
Avatar.propTypes = {
  children: _propTypes["default"].node,
  /**
   * Avatar theme
   */
  theme: _propTypes["default"].object,
  /**
   * Specifies the size of the avatar
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(Object.values(_oxygenConstants.avatarSize)), _propTypes["default"].number]),
  /**
   * Specifies the user status or a render-able element. User status is available only for sizes between xs and 2xl
   */
  userStatus: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(Object.values(_oxygenConstants.avatarUserStatus)), _propTypes["default"].element]),
  /**
   * Specifies if the component shows a border
   */
  hasBorder: _propTypes["default"].bool,
  /**
   * Specifies if the group placeholder should be used
   */
  isGroup: _propTypes["default"].bool,
  /**
   * Specifies the name after which the initials are computed
   */
  name: _propTypes["default"].string,
  /**
   * How many initials to show
   */
  maxInitials: _propTypes["default"].number,
  /**
   * Callback for the avatar on-click event
   */
  onClick: _propTypes["default"].func,
  /**
   * Callback for the edit overlay on-click event
   */
  onEdit: _propTypes["default"].func,
  /**
   * Specifies the image source
   */
  src: _propTypes["default"].string,
  /**
   * Specifies if the edit overlay should be displayed. The edit overlay is available only for sizes between l and 3xl
   */
  showEditOverlay: _propTypes["default"].bool,
  /**
   * Test ID
   */
  testId: _propTypes["default"].string,
  hasStatusBorder: _propTypes["default"].bool,
  isActive: _propTypes["default"].bool
};
Avatar.defaultProps = {
  children: null,
  theme: {},
  size: 'medium',
  userStatus: null,
  hasBorder: false,
  isGroup: false,
  name: '',
  maxInitials: 2,
  onClick: undefined,
  onEdit: function onEdit() {
    return false;
  },
  src: '',
  showEditOverlay: false,
  testId: 'AVATAR',
  hasStatusBorder: false,
  isActive: false
};
var _default = (0, _oxygenConfig.withTheme)(Avatar, 'avatar');
exports["default"] = _default;